import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './theme.css';
import MainView from './Components/main-view/main-view';
import LoginView from './Components/login-view/login-view';
import SignupView from './Components/signup-view/signup-view';
import { ProfileView } from './Components/profile-view/profile-view';
import MovieView from './Components/movie-view/movie-view';
import NavigationBar from './Components/navigation-bar/navigation-bar';

const App = () => {
    const [user, setUser] = React.useState(
        JSON.parse(localStorage.getItem('user')) || null
    );
    const [token, setToken] = React.useState(localStorage.getItem('token') || null);

    console.log("App rendered. Token:", token);

    const handleLogout = () => {
        setUser(null);
        setToken(null);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
    };

    React.useEffect(() => {
        const onUserUpdated = (e) => {
            const updated = e.detail;
            if (updated) {
                setUser(updated);
                localStorage.setItem('user', JSON.stringify(updated));
            }
        };
        window.addEventListener('userUpdated', onUserUpdated);
        return () => window.removeEventListener('userUpdated', onUserUpdated);
    }, []);

    return (
        <BrowserRouter>
            <NavigationBar user={user} onLogout={handleLogout} />
            <Routes>
                <Route
                    path="/login"
                    element={
                        user ? (
                            <Navigate to="/" />
                        ) : (
                            <LoginView onLoggedIn={(user, token) => {
                                setUser(user);
                                setToken(token);
                                localStorage.setItem('user', JSON.stringify(user));
                                localStorage.setItem('token', token);
                            }} />
                        )
                    }
                />
                <Route
                    path="/signup"
                    element={user ? <Navigate to="/" /> : <SignupView />}
                />
                <Route
                    path="/profile"
                    element={
                        user
                            ? <ProfileView user={user} token={token} setUser={setUser} onLogout={handleLogout} />
                            : <Navigate to="/login" />
                    }
                />
                <Route
                    path="/movies/:movieId"
                    element={user ? <MovieView token={token} /> : <Navigate to="/login" />}
                />
                <Route
                    path="/"
                    element={
                        user
                            ? <MainView token={token} onLogout={handleLogout} />
                            : <Navigate to="/login" />
                    }
                />
            </Routes>
        </BrowserRouter>
    );
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);